/**
 * Aufgaben-Board (Welle 1, docs/tasks/aufgaben-board.md).
 *
 * Die Farbe ist ein TOKEN-NAME, kein Hex-Wert — die Farbwerte liegen im Theme
 * (`theme.palette.boardSpalte`). Damit bleibt die Design-System-Regel „keine
 * hartkodierten Hex-Farben" auch fuer nutzerdefinierte Spalten gueltig.
 */
export type BoardFarbe = 'grau' | 'blau' | 'gruen' | 'gelb' | 'rot' | 'lila';

export const BOARD_FARBEN: BoardFarbe[] = ['grau', 'blau', 'gruen', 'gelb', 'rot', 'lila'];

export interface BoardSpalteDto {
  id: number;
  name: string;
  color: BoardFarbe;
  sort_order: number;
}
